/* 2026-07-23: this script no longer touches #cstm-property-preorder.
   The buy-buttons.liquid inline updater is the SOLE owner of the Pre line-item
   property (eligibility: custom.preorder_active via potVariantData). This script
   previously also toggled the input using DIFFERENT eligibility (enable_preorder
   + inventory > preorder_quantity), so where the two flags disagreed the stamp
   depended on which handler ran last — nondeterministic per interaction.
   Button text / sold-out / notify UI behaviour is unchanged. */
document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector('form[action*="/cart/add"] input[name="id"]')) return;

    const selectedVariantId = document.querySelector('input[name="id"]')?.value,
        variant = window.metaVariants.find(v => v.id == selectedVariantId);
    if (!variant) return;

    const continueSelling = variant.inventory_policy === "continue",
        enablePreorder = variant.metafields?.enable_preorder,
        inventoryQty = variant.inventory_quantity,
        preorderQty = parseInt(variant.metafields?.preorder_quantity || 0),
        button_text = document.querySelectorAll(".product_custom_text");

    continueSelling && enablePreorder && inventoryQty > preorderQty ? button_text.forEach(el => {
        el.style.display = "none"
    }) : variant.available ? button_text.forEach(el => {
        el.style.display = "block"
    }) : button_text.forEach(el => {
        el.style.display = "none"
    }),

    document.addEventListener("change", function (event) {
        // console.log("change")
        const stickyForm = document.querySelector("product-sticky-form");
        if (!stickyForm) return;
        const stickyButton = stickyForm.querySelector('button[name="add"]'),
        //  console.log("change",stickyButton.length )
            stickyMessageEls = stickyForm.querySelectorAll(".pre-order-messages_txt"),
            form = event.target.closest('form[action*="/cart/add"]');
        if (!form) return;

        const variantIdInput2 = form.querySelector('input[name="id"]');
        if (!variantIdInput2) return;

        const selectedVariantId2 = parseInt(variantIdInput2.value),
            variant2 = window.metaVariants.find(v => v.id === selectedVariantId2);
//            variant2 = window.productVariants.find(
//   v => Number(v.id) === Number(selectedVariantId2)
// );
        if (!variant2) return;
//         console.log("selectedVariantId2:", selectedVariantId2, typeof selectedVariantId2);
// console.log("variants:", window.metaVariants);
        const button = form.querySelector('button[name="add"]');
        if (!button) return;

        const notifyBtn = document.getElementById('openNotifyModal');
        const continueSelling2 = variant2.inventory_policy === "continue",
            enablePreorder2 = variant2.metafields?.enable_preorder,
            inventoryQty2 = variant2.inventory_quantity,
            preorderQty2 = parseInt(variant2.metafields?.preorder_quantity || 0),
            preorderMessage = variant2.metafields?.preorder_message,
            messageEls = document.querySelectorAll(".pre-order-messages_txt"),
            button_text2 = document.querySelectorAll(".product_custom_text"),
            archive_text = document.querySelectorAll(".archive-order-messages_txt onload_pre"),
            variant_sku = variant2.sku;


        // console.log("button_text"+window.metaVariants +button_text2+"variant_sku "+ variant_sku,"enablePreorder2",enablePreorder2 ,"inventoryQty2",inventoryQty2,"preorderQty2",preorderQty2);

        continueSelling2 && enablePreorder2 && inventoryQty2 > preorderQty2 ? (messageEls.forEach(el => {
            el.style.display = "block", el.textContent = preorderMessage || ""
        }), button_text2.forEach(el => {
            el.style.display = "none"
        }),
         archive_text.forEach(el => {
            el.style.display = "block"
        })) : variant2.available ? (messageEls.forEach(el => {
            el.style.display = "none"
        }),
        button_text2.forEach(el => {
            el.style.display = "block"
        }),
        archive_text.forEach(el => {
            el.style.display = "none"
        })) : (messageEls.forEach(el => {
            el.style.display = "none"
        }),
         button_text2.forEach(el => {
            el.style.display = "none"
        }),
        archive_text.forEach(el => {
            el.style.display = "none"
        }));

    setTimeout(() => {

  const textSpan = button.querySelector(".btn_text_fill");
  const stickspan = stickyButton.querySelector(".btn_text_fill");

  if (!textSpan) return;

  // 🔴 SOLD OUT
  if (!variant2.available) {

    stickyButton.setAttribute("aria-label", "Sold Out");
    button.setAttribute("aria-label", "Sold Out");

    textSpan.textContent = "Sold Out";
    stickspan.textContent = "Sold Out";

    button.disabled = true;

    if (notifyBtn) {
      notifyBtn.style.display = "block";
    }

    return;
  }

  // 🟡 PREORDER
  if (continueSelling2 && enablePreorder2 && inventoryQty2 > preorderQty2) {

    stickyButton.setAttribute("aria-label", "Pre-order");
    button.setAttribute("aria-label", "Pre-order");

    textSpan.textContent = "Pre-order";
    stickspan.textContent = "Pre-order";

    button.disabled = false;

    if (notifyBtn) {
      notifyBtn.style.display = "none";
    }

    return;
  }

  // 🟢 NORMAL
  stickyButton.setAttribute("aria-label", "Add to cart");
  button.setAttribute("aria-label", "Add to cart");

  textSpan.textContent = "Add to cart";
  stickspan.textContent = "Add to cart";

  button.disabled = false;

  if (notifyBtn) {
    notifyBtn.style.display = "none";
  }

}, 50);
    });

    const closeButton = document.querySelector('button[aria-label="Close cart"]');
    closeButton && closeButton.addEventListener("click", function (event) {
        event.preventDefault();
        const submitButton = document.querySelector('button[type="submit"][name="add"]'),
            btnText = submitButton.querySelector(".btn-text"),
            btnLoader = submitButton.querySelector(".btn-loader");
        btnText && (btnText.style.opacity = "1");
        btnLoader && (btnLoader.style.opacity = "0")
    })
});
